import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { City, Country, State } from "country-state-city";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { Controller, useForm, useWatch } from "react-hook-form";
import "./App.css";
import KenButton from "./GlobalComponents/KenButton";
import KenInput from "./GlobalComponents/KenInput";
import KenLoader from "./GlobalComponents/KenLoader/index";
import KenPhoneInput from "./GlobalComponents/KenPhoneInput";
import KenSelect from "./GlobalComponents/KenSelect";
import { SendOTP } from "./Utils/apiServices";
import VerifyOTP from "./VerifyOTP";
import formData from "./formData.json";
import phone from 'phone';
import _  from "lodash";

const useStyles = makeStyles((theme) => ({
  phoneContainer: {
    display: "flex",
    "& .phone-input": {
      fontFamily: "Poppins,sans-serif",
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "100%",
      border: "1px solid #F5F7F8",
      // color: '#505F79',
      padding: "16px",
      order: 2,
      // background: '#F3F5F7',
      // border: 0,
      height: "57px !important",
      width: "100% !important",
      //   57
      borderRadius: "4px",
      marginLeft: "11px",
      "&::placeholder": {
        fontSize: "16px",
        lineHeight: "100%",
        // color: '#A8AFBC',
        border: "1px solid #F5F7F8",

        fontFamily: "Poppins,sans-serif",
      },
    },
    "& .phone-dropdown": {
      position: "relative",
      order: 1,
      // border: 0,
      border: "1px solid #F5F7F8",

      // background: '#F3F5F7',
      "&.open": {
        // background: '#F3F5F7',
        "& .selected-flag": {
          // background: '#F3F5F7',
        },
      },
      "& .selected-flag": {
        width: "50px",
        padding: "10px",
        background: "#FFFFFF",
        border: "1px solid #F5F7F8",
        "&:hover": {
          // background: '#F3F5F7',
        },
      },
    },
  },
  form: {
    marginTop: "10px",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      padding: "0px 20px",
    },
  },
}));

function App() {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const {
    handleSubmit,
    register,
    getValues,
    control,
    watch,
    formState: { errors },
  } = useForm({ mode: "onChange" });
  const [showVerifyOTP, setShowVerifyOTP] = useState(false);
  const [data, setData] = useState(formData.fields);
  const [leadId, setLeadId] = useState();
  useWatch({ name: "Interested_Level_of_Study__c", control: control });

  console.log(errors, "y56y5656u");
  const [isChecked, setIsChecked] = useState(false);
  const [loader, setLoader] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const phoneValidatonCheck = (value) => {
    const validPhone = phone(value);
    if(validPhone.isValid == false) {
      return 'Please enter valid Phone number';
    }
    
    return true;
  }

  const onSubmit = async (data) => {
    if (isChecked === false) {
      enqueueSnackbar("Please check the declaration box", {
        variant: "error",
      });
    } else {
      setLoader(true);
      try {
        const res = await SendOTP(data.Email, {
          ...data,
          LeadSource: "Website",
          "OwnerId": "005F9000008zbZrIAI"
        });
        setLoader(false);

        if (res?.success) {
          setShowVerifyOTP(true);
          setLeadId(res?.data?.Id);
        } else {
          setLoader(false);
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
      } catch (error) {
        setLoader(false);
        console.error("Error sending OTP:", error);
        enqueueSnackbar("Something went wrong while sending OTP", {
          variant: "error",
        });
      }
    }
  };

  const handleBackClick = () => {
    setShowVerifyOTP(false);
  };

  const renderFormField = (field) => {
    switch (field.type) {
      case "select":
        return renderSelect(field);
      case "phone":
        return renderPhoneInput(field);
      default:
        return renderInput(field);
    }
  };

  const renderSelect = (field) => {
    let customOptions = Array.isArray(field.options)
      ? field.options
      : field.options[getValues(field?.options?.meta?.scope)];
    if (field.name === "Country__c") {
      customOptions = Country.getAllCountries().map(({ name: n }) => ({
        label: n,
        value: n,
      }));
      let removedElement = customOptions.splice(
        customOptions.findIndex((el) => el.label === "India"),
        1
      )[0];
      customOptions.unshift(removedElement);
    }
    const isStateDisabled = field.name === "State__c" && customOptions.length === 0; 
    const isCityDisabled = field.name === "City__c" && customOptions.length === 0;

    // Check if the browser is Firefox
    const isFirefox = typeof InstallTrigger !== 'undefined';

    return (
      <>
        <div style={{ display: isCityDisabled || isStateDisabled ? 'none' : 'block', width: isCityDisabled || isStateDisabled || field.name === 'Academic_Year__c' || field.name === 'Country__c' || field.name === 'State__c' || field.name === 'City__c'? isFirefox ? '-moz-available' : '-webkit-fill-available' : '-webkit-fill-available', paddingLeft: field.name == "Country__c" || field.name == "State__c" || field.name == "City__c" || field.name == "Academic_Year__c"  ? '22px' : '', marginTop: field.name == "Country__c" || field.name == "State__c" || field.name == "City__c" || field.name == "Academic_Year__c"  ? '10px' : ''}}>
          <Controller
            name={field.name}
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <KenSelect
                // required={field.required}
                id={field.name}
                name={field.name}
                label={field.label}
                options={customOptions}
                onChange={onChange}
                value={value}
                error={error?.message}
              />
            )}
            {...((isCityDisabled || isStateDisabled) ? {} : {...register(field.name, { ...field.validations })})}
          />
        </div>
      </>
    );
  };

  const renderPhoneInput = (field) => {
    return (
      <Controller
        name={field.name}
        control={control}
        rules={{
          required: 'This field is Required',
          validate: phoneValidatonCheck,
          maxLength: {
            value: 17,
            message: 'Please input phone number',
          },
        }}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <KenPhoneInput
            required={field.required}
            name={field.name}
            label={field.label}
            containerClass="your-phone-container-class"
            inputClass="your-input-class phone-input"
            buttonClass="your-button-class phone-dropdown"
            country={"in"}
            placeholder="Enter Number"
            onChange={(e) => {
              onChange(e);
            }}
            inputType="circular"
            hideLabel="true"
            value={value}
            error={error?.message}
          />
        )}
      />
    );
  };

  const renderInput = (field) => {
    const getPattern = new RegExp(field?.validations?.pattern?.value);
    return (
      <Controller
        name={field.name}
        control={control}
        render={({ field: fieldData, fieldState: { error } }) => {
          return <KenInput error={error?.message} {...field} {...fieldData} />;
        }}
        {...register(field.name, {
          ...field.validations,
          pattern: {
            value: getPattern,
            message: field?.validations?.pattern?.message,
          },
        })}
      />
    );
  };

  const watchLevelOfStudy = watch("lavelOfStudy");
  const watchCountry = watch("Country__c");
  const watchState = watch("State__c");

  useEffect(() => {
    let formDataCopy = [...data];
    if (watchCountry) {
      formDataCopy.find((el) => el.name === "State__c").options =
        State.getStatesOfCountry(
          Country.getAllCountries().find((con) => con.name === watchCountry)
            ?.isoCode
        ).map(({ name }) => ({
          label: name,
          value: name,
        }));
      formDataCopy.find((el) => el.name === "City__c").options = [];
    }
    if (watchState) {
      formDataCopy.find((el) => el.name === "City__c").options =
        City.getCitiesOfState(
          Country.getAllCountries().find((con) => con.name === watchCountry)
            ?.isoCode,
          State.getAllStates().find((state) => state.name === watchState)
            ?.isoCode
        ).map(({ name }) => ({
          label: name,
          value: name,
        }));
    }
    setData(formDataCopy);
  }, [watchCountry, watchState]);

  return (
    <>
      {loader && <KenLoader />}
      <Grid xs={12} sm={12} md={3}>
        <div
          className="App"
          style={{
            display: "flex",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <div>
            {showVerifyOTP ? (
              <VerifyOTP
                data={{ ...getValues(), leadId: leadId }}
                handleBackClick={handleBackClick}
                email={getValues("Email")}
              />
            ) : (
              <>
                <p style={{ fontSize: "32px", fontWeight: "700 !important" }}>
                  Enquiry Form
                </p>
                <form
                  className={classes.form}
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <Grid container lg={12}>
                    <Grid item lg={3} />
                    <Grid item container lg={6} spacing={3}>
                      {formData.fields.map((field) => (
                        <Grid item lg={6} xs={12} key={field.name} style={{ width: field.name == "Country__c" || field.name == "State__c" || field.name == "City__c" || field.name == "Academic_Year__c" ? '-webkit-fill-available !important' : 'block !important', display: field.name == "Country__c" || field.name == "State__c" || field.name == "City__c" || field.name == "Academic_Year__c" ? 'contents' : 'block' }}>
                          {renderFormField(field)}
                        </Grid>
                      ))}
                    </Grid>
                    <Grid item lg={3} />
                  </Grid>
                  <div style={{ marginTop: "20px" }}>
                    <label style={{ fontSize: "12px" }}>
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                        style={{ width: "15px", height: "15px" }} // Adjust the size here
                      />
                      <span style={{ fontSize: "14px", marginLeft: "5px" }}>
                      I hereby authorize AIMS Institutes to contact me and provide notifications and updates via WhatsApp, SMS, phone calls, or email.
                      </span>
                    </label>
                  </div>
                  <KenButton
                    type="submit"
                    variant="primary"
                    // disabled={isChecked === false ? true : false}
                    style={{ margin: "25px", color: "white !important" }}
                    onClick={() => {
                      const formValues = getValues(); // Get form values
                      console.log(Object.values(formValues), "formValues")
                      const isFormEmpty = Object.values(formValues).some(value => !value);
                      console.log(isFormEmpty, "isFormEmpty")
                      const undefinedCount = Object.values(formValues).filter(value => value === undefined).length;
                      if (isFormEmpty && undefinedCount > 2) {
                        enqueueSnackbar("Please resolve all errors", {
                          variant: 'info',
                        });
                      } else {
                        return;
                      }
                    }}
                  >
                    Get OTP
                  </KenButton>
                </form>
              </>
            )}
          </div>
        </div>
      </Grid>
    </>
  );
}

export default App;
